import * as targetLayout from "../searchResults/targetLayout";

export default function customizeTabForUser(userContent, binderTab, binderType) {
	const targetName = binderTab.search ? binderTab.search.target_name : null;

	if (targetName && targetLayout.hasSavedLayout(userContent, targetName, binderType)) {
		const defaultFields = targetLayout.getSavedFields(userContent, binderType, targetName);
		return {
			...binderTab,
			search: {
				...binderTab.search,
				field_names: defaultFields ? defaultFields : binderTab.search.field_names,
			},
		};
	}

	return binderTab;
}
